<template>
    <div ref="mainHolder">
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <v-layout row wrap v-if="!loading&&ecConfig">
            <v-flex xs12>
                <vue-echart :white-mode="whiteMode" :config="ecConfig" :height="height"></vue-echart>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import {callAPI, getAutotuner} from '@/helper'
import LoadingProgressBar from './../LoadingProgressBar'
import VueEchart from "@/components/VueEchart";

export default {
    props: {
        title: {type: String, default: "Autotuner"},
        dateRange: {type: Object, default: null},
        autotunerId: {type: Number, default: null},
        whiteMode: {type: Boolean, default: false},
        height: {type: Number, default: 490},
    },
    components: {LoadingProgressBar, VueEchart},
    computed: {},
    name: 'AutotunerWidget',
    watch: {
        dateRange() {
            this.refresh()
        },
    },
    data: function () {
        return {
            loading: false,
            timeout: null,
            ecConfig: null,
            reloadInc:0,
            autotuner: null,
        }
    },
    async mounted() {
        if (this.autotunerId) {
            let df = await getAutotuner({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                autotuner_id: this.autotunerId
            })
            this.autotuner = df['result']
            this.refresh()
        }
    },
    methods: {
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        refresh() {
            this.debounce(this.getData, 500);
        },
        async getData() {
            this.ecConfig = null
            this.reloadInc=this.reloadInc+1
            let currentInc=this.reloadInc
            if (this.autotuner && this.autotuner.target) {
                this.loading = true
                let target= this.autotuner.target
                let params= this.autotuner.config.parameters.map(x=>x.sensor)
                let dateRange = this.dateRange ? [this.dateRange.start, this.dateRange.end.length < 12 ? this.dateRange.end + " 23:59:59" : this.dateRange.end] : null;
                let payload = {
                    "filters": {
                        "equipment_name": target.split(" - ")[0],
                        "sensor_name": target.split(" - ")[1],
                        "facility_name": this.$store.state.pointsListStore.pointsList.facility_name
                    },
                    "pipeline": params.map(x=>{return {type:"insert_series",name:x}}),
                    "date_range": dateRange
                }
                let result = await callAPI('data3/', payload)
                if (currentInc!==this.reloadInc){
                    return
                }
                let names=[...params,target]
                let pdIndex=0
                let parallelData=[]
                let parallelTime=[]
                for (let index in result.data.timestamp){
                    if (result.data[target][index]!==null){
                        let line=[]
                        for (let name of names){
                            line.push(result.data[name][index])
                        }
                        line.push(pdIndex)
                        parallelTime.push(result.data.timestamp[index])
                        parallelData.push(line)
                        pdIndex=pdIndex+1
                    }
                }
                this.ecConfig = {
                    title: {
                        text: this.title,
                        left: 'center'
                    },
                    parallelAxis:names.map((item,index)=>{return{dim:index, name:item}}),
                    visualMap: {
                        show: true,
                        min: 0,
                        itemHeight:this.$refs.mainHolder.clientWidth-200,
                        max: pdIndex,
                        orient: 'horizontal',
                        left: 'center',
                        textStyle:process.env.VUE_APP_THEME==='dark' ? {color: "rgba(255, 255, 255, 1)" } : null,
                        formatter:(x)=>{
                            return parallelTime[parseInt(x)]
                        },
                        dimension: names.length,
                        calculable:true,
                    },
                    series: {
                        type: 'parallel',
                        data:parallelData
                    }
                }
                this.loading = false
            }
        }

    },
}

</script>

<style scoped>

</style>
